import showdown, { Converter } from "showdown"
import DOMPurify from "dompurify";

export class MarkdownUtil {
    readonly converter: Converter;
    private static instance = new MarkdownUtil();

    private constructor() {
        // Obs: Extensão quebra imagens em formato base64
        //      Entretanto não se deve mais envir imagens em base64
        var underline = {
            type: 'lang',
            regex: /\+\+(.*)\+\+/g,
            replace: '<u>$1</u>'
        };

        this.converter = new showdown.Converter({extensions: [underline]});
        this.converter.setOption('tables', true);
        this.converter.setOption('ghCodeBlocks', true);
        this.converter.setOption('tasklists', true);
        this.converter.setOption('emoji', true);
        this.converter.setOption('omitExtraWLInCodeBlocks', true);
        this.converter.setOption('parseImgDimensions', true);
        this.converter.setOption('ghMentions', false);
        this.converter.setOption('strikethrough', true);
    }

    static toHtml(markdown: string): string {
        const html = this.instance.converter.makeHtml(markdown);

        return DOMPurify.sanitize(html);
    }

    static toMarkdown(html: string): string {
        const markdown = this.instance.converter.makeMarkdown(html).trim();

        return markdown.replaceAll("<br>", "\n");
    }

    static toMarkdownOrUndefined(html?: string): string|undefined {
        return html !== undefined
            ? MarkdownUtil.toMarkdown(html)
            : html;
    }
}